module.exports = __webpack_public_path__ + "static/media/MoB_press_kit.94870497.zip";